import LanguageButton from './language-button';

export default LanguageButton;
